import { LegalClientBeneficiaryEntity } from 'api/types/entity';
import { formatToDate, yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import {
  parseAddressValue,
  parseTaxResidencesValue,
  parsePepConnectionInitialValue,
  parseResidentialAddressValue,
  parseIdentityDocumentWithFilesInitialValue,
  parseCitizenshipsValue,
} from 'modules/client/common/helpers';

import { ControlOverFormType } from '../../forms/controlOverForm';
import { LegalClientBeneficiaryFormType } from '../../forms/legalClientBeneficiaryForm';

export const getLegalClientBeneficiaryInitialValue = (
  client: LegalClientBeneficiaryEntity,
  t: TFunc
): LegalClientBeneficiaryFormType => ({
  contacts: {
    email: client.email,
  },

  reasonChange: { reason: '' },

  placeOfBirth: {
    country: client.placeOfBirth?.country ?? null,
    locality: client.placeOfBirth?.locality ?? '',
  },

  personalData: {
    firstName: client.firstName,
    lastName: client.lastName,
    middleName: client.middleName ?? '',
    dateOfBirth: client.dateOfBirth,
  },

  citizenships: parseCitizenshipsValue(client.citizenships),

  taxResidences: parseTaxResidencesValue(client.taxResidences),

  registrationAddress: parseAddressValue(client.registrationAddress),
  residentialAddress: parseResidentialAddressValue(client.residentialAddress),

  pepConnection: parsePepConnectionInitialValue(client.pepConnection, t),

  controlOver: client.controlOver
    ? {
        directCapitalParticipationPercentage:
          client.controlOver.directCapitalParticipationPercentage,
        financialConditionAmount: client.controlOver.financialConditionAmount,
        hasControlOverLegalClient: yesOrNotOption(
          t,
          client.controlOver.hasControlOverLegalClient
        ),
        indirectCapitalParticipationPercentage:
          client.controlOver.indirectCapitalParticipationPercentage,

        controlOverLegalClientStatus: client.controlOver
          .controlOverLegalClientStatus
          ? {
              label: t(
                `client.legal.legalClientBeneficiary.controlOver.controlOverLegalClientStatus.types.${client.controlOver.controlOverLegalClientStatus}`
              ),
              value: client.controlOver.controlOverLegalClientStatus,
            }
          : undefined,
      }
    : ({} as ControlOverFormType['controlOver']),

  activity: {
    id: client.id,
    createdAt: formatToDate(client.createdAt),
  },

  identityDocument: parseIdentityDocumentWithFilesInitialValue(
    t,
    client.identityDocument
  ),

  additionalDocumentsFiles: client.additionalInformationFiles,
});
